import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{staticClass:"mt-5",attrs:{"type":"warning"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.$t("global.processing")))])])}
var staticRenderFns = []

export { render, staticRenderFns }